import React from 'react';
import styled from 'styled-components';
import {
  FiArrowLeft,
  FiMapPin,
  FiClock,
  FiChevronUp,
  FiChevronDown,
  FiCheck,
  FiPlus,
  FiShoppingCart,
  FiTrash,
  FiInfo,
  FiCreditCard,
  FiArrowRight,
  FiLock,
  FiEdit2,
  FiClipboard,
  FiSave,
} from 'react-icons/fi';
import corn from '../../images/allergens/corn.png';
import crustean from '../../images/allergens/crustean.png';
import dairy from '../../images/allergens/dairy.png';
import egg from '../../images/allergens/egg.png';
import fish from '../../images/allergens/fish.png';
import gluten from '../../images/allergens/gluten.png';
import KR from '../../images/allergens/KR.png';
import lactose from '../../images/allergens/lactose.png';
import LU from '../../images/allergens/LU.png';
import mustard from '../../images/allergens/mustard.png';
import no_trans_fat from '../../images/allergens/no trans fat.png';
import nut from '../../images/allergens/nut.png';
import peanut from '../../images/allergens/peanut.png';
import SE from '../../images/allergens/SE.png';
import SL from '../../images/allergens/SL.png';
import SO from '../../images/allergens/SO.png';
import sugar from '../../images/allergens/sugar.png';
import vegan from '../../images/allergens/vegan.png';
import WE from '../../images/allergens/WE.png';

const iconMap = {
  // allergens: @FIXME: key should match graphql allergy value
  corn,
  crustean,
  dairy,
  egg,
  fish,
  gluten,
  KR,
  lactose,
  LU,
  mustard,
  no_trans_fat,
  nut,
  peanut,
  SE,
  SL,
  SO,
  sugar,
  vegan,
  WE,
  // feather icons
  arrow_left: <FiArrowLeft />,
  arrow_right: <FiArrowRight />,
  clock: <FiClock />,
  mapPin: <FiMapPin />,
  angle_up: <FiChevronUp />,
  angle_down: <FiChevronDown />,
  check: <FiCheck />,
  plus: <FiPlus />,
  cart: <FiShoppingCart />,
  trash: <FiTrash />,
  save: <FiSave />,
  info: <FiInfo />,
  card: <FiCreditCard />,
  lock: <FiLock />,
  edit: <FiEdit2 />,
  clipboard: <FiClipboard />,
};

const IconContainer = styled.div`
  padding-top: ${(props) => props.paddingTop || 0}px;
  width: min-content;
  height: min-content;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ color }) => (color ? `color: ${color};` : '')};
`;

function Icon({ name, ...props }) {
  return <IconContainer {...props}>{iconMap[name]}</IconContainer> || null;
}

export default Icon;
